(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .filter('sortBy', sortBy);

  // @ngInject
  function sortBy() {
    return function(array, key, orderBy) {
      var formatted = _.orderBy(array, [key], [orderBy]);
      return formatted;
    };
  }

})();